// A person's preferences, the same on the server and in the app. "system" follows the device's light or dark setting.
export const THEMES = ['system', 'light', 'dark'] as const
export type Theme = (typeof THEMES)[number]

// How things move: "smooth" lets photos grow from where they sit and slide from one to the next, and the first
// sign-in build as it goes; "simple" keeps to quick fades. A device set to reduce motion always gets "simple".
export const MOTIONS = ['smooth', 'simple'] as const
export type Motion = (typeof MOTIONS)[number]

export type Preferences = { theme: Theme; motion: Motion }
export const DEFAULT_PREFERENCES: Preferences = { theme: 'system', motion: 'smooth' }

export const isTheme = (value: unknown): value is Theme => THEMES.includes(value as Theme)
export const isMotion = (value: unknown): value is Motion => MOTIONS.includes(value as Motion)
